import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Phone, Menu, X, Facebook, Instagram, Linkedin, Youtube, ClipboardPlus } from "lucide-react";
import { CONTACT } from "../mock";

const NAV = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Service Areas", to: "/service-areas" },
  { label: "Resources", to: "/resources" },
  { label: "Careers", to: "/careers" },
  { label: "Contact", to: "/contact" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  const linkClass = ({ isActive }) =>
    `text-[15px] font-semibold transition-colors ${isActive ? "text-[#4ca82f]" : "text-[#2b3a4a] hover:text-[#4ca82f]"}`;

  return (
    <header className="sticky top-0 left-0 w-full z-50">
      {/* Top bar */}
      <div className="w-full text-white" style={{ background: "linear-gradient(90deg,#1b4f9c 0%,#16357a 100%)" }}>
        <div className="max-w-[1240px] mx-auto px-4 h-9 flex items-center justify-between">
          <div className="flex items-center gap-3">
            {[Facebook, Instagram, Linkedin, Youtube].map((Icon, i) => (
              <a key={i} href="#" className="w-6 h-6 rounded-full bg-white/15 hover:bg-white/30 transition-colors flex items-center justify-center"><Icon size={13} /></a>
            ))}
          </div>
          <a href={`tel:${CONTACT.phoneRaw}`} className="flex items-center gap-2 text-[13px] font-semibold hover:opacity-90">
            <Phone size={14} /> {CONTACT.phone}
          </a>
        </div>
      </div>

      {/* Main nav */}
      <div className={`w-full bg-white transition-shadow ${scrolled ? "shadow-md" : "shadow-sm"}`}>
        <div className="max-w-[1240px] mx-auto px-4 h-[92px] flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center flex-shrink-0">
            <img src="/carefirst-logo.png" alt="CareFirst Home Health Services LLC - Columbus, Ohio" className="h-[74px] w-auto object-contain" />
          </Link>
          <nav className="hidden xl:flex items-center gap-6">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} className={linkClass} end={n.to === "/"}>{n.label}</NavLink>
            ))}
          </nav>
          <div className="hidden xl:flex">
            <Link to="/referral" className="inline-flex items-center gap-2 bg-[#4ca82f] hover:bg-[#3d8a26] text-white font-bold px-6 py-3 rounded-full text-[14px] shadow-md transition-colors">
              <ClipboardPlus size={18} /> Make a Referral
            </Link>
          </div>
          <button className="xl:hidden text-[#16357a]" onClick={() => setOpen(!open)} aria-label="Toggle menu">
            {open ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
        {open && (
          <div className="xl:hidden bg-white border-t border-gray-100 px-4 py-3">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} end={n.to === "/"} className="block py-2.5 text-[15px] font-semibold text-[#2b3a4a] hover:text-[#4ca82f]">{n.label}</NavLink>
            ))}
            <Link to="/referral" className="mt-3 inline-flex items-center gap-2 bg-[#4ca82f] text-white font-bold px-6 py-3 rounded-full text-[14px] w-full justify-center">
              <ClipboardPlus size={18} /> Make a Referral
            </Link>
          </div>
        )}
      </div>
    </header>
  );
};

export default Navbar;
